import { useNavigate } from '@tanstack/react-router'

import {
  Button,
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
  Text,
} from '@/components/ui'

type Props = {
  trigger: React.ReactNode
}

export const LogoutDialog = ({ trigger }: Props) => {
  const navigate = useNavigate()

  return (
    <DialogRoot>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ログアウト</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text>アカウントからログアウトしますか？</Text>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="solid" colorPalette="gray">
              キャンセル
            </Button>
          </DialogActionTrigger>
          <DialogActionTrigger asChild>
            <Button
              onClick={() => {
                navigate({
                  to: '/logout',
                })
              }}
            >
              ログアウト
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  )
}
